// Özet sağ rail: "Yanıt bekleyen notlar (n)" — son mesajı müşteriden gelen hücreler (bugünkü
// `clientNote` kuyruk sütununun yerine, spec §8.4). Satır → iş parçacığı modalı ("Yanıtla").
// Kaynak `note-summary` (yüklü yıllar); özet boşsa kart hiç çizilmez (gürültü yok).

import { useMemo, useState } from "react";
import type { KpiNoteSummaryCell, KpiResolvedGrid } from "@mahir/shared";
import { KPI_NOTES_COPY } from "../../lib/kpi-notes-copy";
import { pendingReplyCells } from "../../lib/kpi-notes-ui";
import { KpiNoteThreadModal } from "./KpiNoteThreadModal";

export function KpiPendingNotes(props: {
  grid: KpiResolvedGrid;
  cells: KpiNoteSummaryCell[];
  reload: () => void;
}): JSX.Element | null {
  const { grid, cells, reload } = props;
  const C = KPI_NOTES_COPY.internal;
  const pending = useMemo(() => pendingReplyCells(cells), [cells]);
  const [open, setOpen] = useState<KpiNoteSummaryCell | null>(null);
  const labelOf = useMemo(
    () => new Map(grid.indicators.map((i) => [i.metricId, i.label])),
    [grid.indicators],
  );
  const entityOf = useMemo(
    () => new Map(grid.entities.map((e) => [e.id, e.name])),
    [grid.entities],
  );
  // Modal liste boşalsa da (yanıt sonrası hücre bekleyenlerden düşer) AÇIK kalır — kart ayrı koşullu
  return (
    <>
      {pending.length > 0 ? (
        <section
          data-testid="kpi-pending-notes"
          aria-label={C.pendingTitle(pending.length)}
          className="rounded-xl p-3"
          style={{ background: "var(--color-surface)", border: "1px solid var(--color-border)" }}
        >
          <div className="text-sm font-semibold mb-1" style={{ color: "var(--color-text)" }}>
            {C.pendingTitle(pending.length)}
          </div>
          <div className="text-xs mb-2" style={{ color: "var(--color-text-3)" }}>
            {C.pendingHint}
          </div>
          <ul style={{ listStyle: "none", margin: 0, padding: 0, display: "grid", gap: 4 }}>
            {pending.map((c) => {
              const label = labelOf.get(c.metricId) ?? c.metricId;
              const entity = entityOf.get(c.entityId);
              return (
                <li key={`${c.metricId}|${c.entityId}|${c.year.toString()}`}>
                  <button
                    type="button"
                    data-testid="kpi-pending-note"
                    onClick={() => setOpen(c)}
                    className="text-xs text-left"
                    style={{ color: "var(--color-primary)", minHeight: 28 }}
                  >
                    {label} · {c.year}
                    {entity ? ` · ${entity}` : ""} — {C.reply}
                  </button>
                </li>
              );
            })}
          </ul>
        </section>
      ) : null}
      {open ? (
        <KpiNoteThreadModal
          open
          title={C.threadFor(labelOf.get(open.metricId) ?? "", open.year)}
          setId={grid.setId}
          cell={{ metricId: open.metricId, entityId: open.entityId, year: open.year }}
          onClose={() => setOpen(null)}
          onChanged={reload}
        />
      ) : null}
    </>
  );
}
